(function () {
  var revealSelector = [
    '.mrts-band',
    '.mrts-trust-credentials',
    '.mrts-premium-strip',
    '.mrts-card',
    '.mrts-process-step',
    '.mrts-proof-hub__card',
    '.mrts-media-gallery__item',
    '.mrts-trust-card',
    '.multicolumn-card'
  ].join(',');

  if (!('IntersectionObserver' in window)) return;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  document.documentElement.classList.add('mrts-reveal-ready');

  var items = Array.prototype.slice.call(document.querySelectorAll(revealSelector));
  items.forEach(function (item, index) {
    item.classList.add('mrts-reveal');
    item.style.setProperty('--mrts-reveal-index', index % 6);
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -12% 0px',
    threshold: 0.12
  });

  items.forEach(function (item) {
    observer.observe(item);
  });
}());
